import { MuiComponent } from "./type";
import * as Colors from "../colors";

export const MuiSwitch: MuiComponent<"MuiSwitch"> = {
  styleOverrides: {
    root: {
      width: 40,
      height: 22,
      padding: 0,
      display: "flex",
      alignItems: "center",
    },
    switchBase: {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(18px)",
        color: "#fff",
        
        "& + .MuiSwitch-track": {
          backgroundColor: Colors.Purple,
          opacity: 1,
        },
      },

      "& + .MuiSwitch-track": {
        backgroundColor: Colors.BorderGray,
        opacity: 1,
      },

      "&.Mui-disabled": {
        "& .MuiSwitch-thumb": {
          backgroundColor: Colors.LightGray,
        },

        "& + .MuiSwitch-track": {
          backgroundColor: Colors.BorderGray,
          opacity: 1,
        },

        "&.Mui-checked + .MuiSwitch-track": {
          backgroundColor: Colors.Purple,
        },
      },
    },
    thumb: {
      width: 18,
      height: 18,
      backgroundColor: "#fff",
      boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.3)",
    },
    track: {
      borderRadius: 24,
      backgroundColor: Colors.Gray,
      opacity: 1,
      transition: "background-color 0.2s ease-in-out",
    },
  },
};
